import React, { useEffect, useState } from 'react'
import moment from "moment";
import axios from "axios";

import callPostApi from "requests/PostRequests";
import * as Constants from "../../../requests/URLConstants";
import DashboardSummary from '../DashboardSummaryNew';
import * as DashboardUtils from "../DashboardUtils.js";
import DashboardGaugeChart from '../DashboardGaugeChart';
import DashboardLineChart from '../DashboardLineChart';
import * as DashboardConstants from '.././DashboardConstants';
import './_productivity-metrics.scss';
import * as workspaces from '../../../config/WorkspaceConstants'

export default function ProductivityMetrics(props) {
    const [metricsLoading, setMetricsLoading] = useState(false);
    const [gaugeChartLoading, setGaugeChartLoading] = useState(false);
    const [SuccessRateLoading, setSuccessRateLoading] = useState(false)
    const [SuccessRateLineChartLoading, setSuccessRateLineChartLoading] = useState(false);
    const [RunsOnTimeLoading, setRunsOnTimeLoading] = useState(false);
    const [StartedOnTimeLoading, setStartedOnTimeLoading] = useState(false);
    const [RunsOnTimeLineChartLoading, setRunsOnTimeLineChartLoading] = useState(false);
    const [StartedOnTimeLineChartLoading, setStartedOnTimeLineChartLoading] = useState(false);
    const [criticalResolutionTime, setCriticalResolutionTime] = useState([]);
    const [NormalResolutionTime, setNormalResolutionTime] = useState([]);
    const [criticalResponseTime, setCriticalResponseTime] = useState([]);
    const [normalResponseTime, setNormalResponseTime] = useState([]);
    const [criticalResolutionColor, setCriticalResolutionColor] = useState("");
    const [normalResolutionColor, setNormalResolutionColor] = useState("");
    const [criticalResponseColor, setCriticalResponseColor] = useState("");
    const [normalResponseColor, setNormalResponseColor] = useState("");
    const [successRateData, setSuccessRateData] = useState([]);
    const [metricsSummaryData, setMetricsSummaryData] = useState([]);
    const [automataRunsdata, setAutomataRunsData] = useState([]);
    const [automataStartsdata, setAutomataStartsData] = useState([]);
    const [automataRunsLineData, setAutomataRunsLineData] = useState([]);
    const [automataStartsLineData, setAutomataStartsLineData] = useState([]);
    const [successRateLineData, setSuccessRateLineData] = useState([]);

    useEffect(() => {
        getResolutionTimeCritical(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getResolutionTimeNormal(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getReponseTimeCritical(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getReponseTimeNormal(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getSuccessRate(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getSuccessRateLineGraph(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataRunsOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataStartsOnTime(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataRunsOnTimeLineGraph(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAutomataStartsOnTimeLineGraph(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getmetricsSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);

    }, [props.preferencesChanged]);


    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                filters: {
                    time: {
                        startDateTime: timeFilterSelections.startDateTime,
                        endDateTime: timeFilterSelections.endDateTime,
                    },
                    geos: dashboardFilterSelectionsAutomation.geo,
                    business_competencies: dashboardFilterSelectionsAutomation.competency,
                    buisness_component: dashboardFilterSelectionsAutomation.buisness_component,
                    process_name: dashboardFilterSelectionsAutomation.process_name,
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,

                },
                interval: {
                    calender_Interval: calenderInterval,
                    time_zone: timeZone,
                },
                workspace: workspace,
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                filters: {
                    time: {
                        startDateTime: timeFilterSelections.startDateTime,
                        endDateTime: timeFilterSelections.endDateTime,
                    },
                    franchises: franchise,
                    clients: client,
                    technologies: technology,
                    assignment_groups: dashboardFilterSelectionsSAP.assigned_group,
                    incident_status: dashboardFilterSelectionsSAP.incident_status,
                    automata_priority: dashboardFilterSelectionsSAP.priority,
                },
                interval: {
                    calender_Interval: calenderInterval,
                    time_zone: timeZone,
                },
                workspace: workspace,
            };
        }
        return bodyJSON;
    };

    /**
     * Builds the gauge chart data 
     * @returns {array} - gauge chart data
     */
    const prepareGuageChartData = (response, type) => {
        let GraphData = [], resolutionTime = {};
        if (response) { resolutionTime = response.aggregations; }
        let value = {}, targetValue = {};
        switch (type) {
            case DashboardConstants.CriticalResolutionTime:
                value = resolutionTime.resolution_time_critical.value === null ? 0 : resolutionTime.resolution_time_critical.value;
                //targetValue = 95;
                break;
            case DashboardConstants.NormalResolutionTime:
                value = resolutionTime.resolution_time_normal.value === null ? 0 : resolutionTime.resolution_time_normal.value;
                //targetValue = 80;
                break;
            case DashboardConstants.CriticalResponseTime:
                value = resolutionTime.response_time_critical.value === null ? 0 : resolutionTime.response_time_critical.value;
                //targetValue = 95;
                break;
            case DashboardConstants.NormalResponseTime:
                value = resolutionTime.response_time_normal.value === null ? 0 : resolutionTime.response_time_normal.value;
                //targetValue = 80;
                break;
            case DashboardConstants.AutomataRunsOnTimeMetrics:
                value = resolutionTime.automata_runs_on_time.value === null ? 0 : resolutionTime.automata_runs_on_time.value;
                // targetValue = 95;
                break;
            case DashboardConstants.AutomataStartsOnTimeMetrics:
                value = resolutionTime.automata_starts_on_time.value === null ? 0 : Math.round(resolutionTime.automata_starts_on_time.value);
                //targetValue = 95;
                break;
            case DashboardConstants.Successrate:
                value = response.avgSucessRate;
                //targetValue = 95;
                break;
            default: break;
        }
        GraphData = [
            {
                "group": "value",
                "value": value
            },
            // {
            //     "group": "delta",
            //     "value": targetValue
            // }
        ];

        return GraphData;
    }

    /**
     * Builds the dashboard summary data 
     * @returns {array} - summary  data
     */
    const prepareSummaryData = (hoursValue, botsData, resources) => {

        let summary = [
            {
                title: DashboardConstants.SavedHours,
                value: isNaN(hoursValue) ? 0 : hoursValue,
            },
            {
                title: DashboardConstants.NumberOfResources,
                value: isNaN(resources.numberOfResources) ? 0 : botsData,
            },
            {
                title: DashboardConstants.ResourceUtilization,
                value: isNaN(resources.utilization) ? 0 : resources.utilization,
                showPercent: true
            },
            {
                title: DashboardConstants.OnboardedBots,
                value: isNaN(botsData) ? 0 : resources.numberOfResources,
            },
        ];
        setMetricsSummaryData(summary);
    };

    /**
     * Builds the Line Graph data 
     * @returns {array} - Line Graph data
     */
    const prepareLineGraphData = (response, graphType) => {
        let data = [];
        let obj = {};
        let dateValue, month;
        if (response) {
            let buckets = response.aggregations["time"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                dateValue = new Date((buckets[i].key_as_string).substr(0, buckets[i].key_as_string.indexOf(' ')));
                month = dateValue.toLocaleString('default', { month: 'short' });
                obj = {
                    group: month,
                    date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                    value: graphType === DashboardConstants.AutomataRunsOnTimeMetrics ? buckets[i].automata_runs_on_time.value : buckets[i].automata_starts_on_time.value
                }
                data.push(obj);
            }
        }
        return data;
    };

    const prepareSuccessRateData = (response) => {
        let buckets = [];
        let avgSucessRate = 0;
        let successRatePercentage = {};

        if (response) {
            buckets = response.aggregations.priority.buckets;
            for (let i = 0; i < buckets.length; i++) {
                avgSucessRate = (avgSucessRate + ((buckets[i].Completions.value / (buckets[i].doc_count - buckets[i].ReRuns.value + buckets[i].SchdMiss.value)) * 100));
            }
        }
        successRatePercentage = { avgSucessRate: avgSucessRate ? (avgSucessRate / buckets.length) : 0 };
        return successRatePercentage;
    };

    const prepareSuccessRateLineChart = (resp1) => {
        let buckets = [];
        let successRate;
        let data = [];
        let graphObj = {};
        if (resp1) {
            buckets = resp1.aggregations["Time"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                successRate = (buckets[i].Completions.value / (buckets[i].doc_count - buckets[i].ReRuns.value + buckets[i].SchdMiss.value)) * 100;
                let dateObj = new Date((buckets[i].key_as_string).substr(0, buckets[i].key_as_string.indexOf(' '))).toLocaleString('default', { month: 'short' });
                graphObj = {
                    group: dateObj,
                    date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                    value: successRate ? successRate.toFixed(2) : 0
                };

                data.push(graphObj);
            }
        }
        return data;
    }

    /**
     * returns the criticalResolutionTime Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {critical resolution Time} - critical  resolution time(%) Array
     */
    function getResolutionTimeCritical(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setGaugeChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETCRITICALRESOLUTIONTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.CriticalResolutionTime);
                    //console.log(formattedData);
                    setCriticalResolutionColor(resp.aggregations.resolution_time_critical.value < 95 || resp.aggregations.resolution_time_critical.value === null ? "#da1e28" : "#006400");
                    setCriticalResolutionTime(formattedData);
                    setGaugeChartLoading(false);
                })
                .catch((error) => {
                    setGaugeChartLoading(false);
                });
        }

    }

    /**
     * returns the normalResolutionTime Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {normal resolution Time} - normal resolution time(%) Array
     */
    function getResolutionTimeNormal(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setGaugeChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETNORMALRESOLUTIONTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.NormalResolutionTime);
                    setNormalResolutionColor(resp.aggregations.resolution_time_normal.value < 80 || resp.aggregations.resolution_time_normal.value === null ? "#da1e28" : "#006400");
                    setNormalResolutionTime(formattedData);
                    setGaugeChartLoading(false);
                })
                .catch((error) => {
                    setGaugeChartLoading(false);
                });
        }

    }

    /**
        * returns the critical Response Time Data
        * @param {*} timeFilterSelections - Time interval Request
        * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
        * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
        * @param {*} workspace - WorkSpace Selection Request
        * @returns {critical response Time} - critical response time(%) Array
        */
    function getReponseTimeCritical(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setGaugeChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETCRITICALRESPONSETIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.CriticalResponseTime);
                    setCriticalResponseColor(resp.aggregations.response_time_critical.value < 95 || resp.aggregations.response_time_critical.value === null ? "#da1e28" : "#006400");
                    setCriticalResponseTime(formattedData);
                    setGaugeChartLoading(false);
                })
                .catch((error) => {
                    setGaugeChartLoading(false);
                });
        }

    }

    /**
         * returns the normalResponse Data
         * @param {*} timeFilterSelections - Time interval Request
         * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
         * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
         * @param {*} workspace - WorkSpace Selection Request
         * @returns {normal response Time} - normal response time(%) Array
         */
    function getReponseTimeNormal(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setGaugeChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETNORMALRESPONSETIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.NormalResponseTime);
                    setNormalResponseColor(resp.aggregations.response_time_normal.value < 80 || resp.aggregations.response_time_normal.value === null ? "#da1e28" : "#006400");
                    setNormalResponseTime(formattedData);
                    setGaugeChartLoading(false);
                })
                .catch((error) => {
                    setGaugeChartLoading(false);
                });
        }

    }

    /**
     * returns the successRate Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {Success Rate} - AVG Success Rate(%) Array
     */
    const getSuccessRate = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let formattedData = [], successRatePercent = [];
            setSuccessRateLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAUTOMATIONTRUSTINDEXSUMMARYSHAREDPROD, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response => {
                    formattedData = prepareSuccessRateData(response);
                    successRatePercent = prepareGuageChartData(formattedData, DashboardConstants.Successrate);
                    setSuccessRateData(successRatePercent);
                    setSuccessRateLoading(false);
                }).catch((error) => {
                    setSuccessRateLoading(false);
                });
        }
    }

    function getSuccessRateLineGraph(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let formattedData = [];
            setSuccessRateLineChartLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.SUCCESSRATELINEGRAPH, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp1 => {
                    formattedData = prepareSuccessRateLineChart(resp1);
                    setSuccessRateLineData(formattedData);
                    setSuccessRateLineChartLoading(false);
                    //,callPostApi(Constants.GETMETRICSTOTALRUN, {
                    //     'Content-Type': 'application/json'
                    // }, bodyJSON)
                    //     .then(resp2 => {
                    //         if (resp2) {
                    //             return resp2;
                    //         }
                    //     })
                }).catch((error) => {
                    setSuccessRateLineChartLoading(false);
                });
        }
    }

    /**
     * returns the metricsSummary Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {metricsSummary} - Metrics Summary(%) Array
     */
    function getmetricsSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setMetricsLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            axios.all([callPostApi(Constants.GETHOURSSAVED, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp1 => {
                    if (resp1) {
                        let hoursValue = (resp1.aggregations.hours_saved.value).toFixed(2);
                        return hoursValue;
                    }
                }),
            callPostApi(Constants.GETONBOARDEDBOTS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp2 => {
                    if (resp2) {
                        let botsData = resp2.aggregations.onboarded_bots.value;
                        return botsData;
                    }
                }),
            callPostApi(Constants.GETRESOURCES, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp3 => {
                    if (resp3) {
                        let resources = {};
                        let numberOfResources = resp3.aggregations.number_of_resources.value;
                        resources["numberOfResources"] = numberOfResources;
                        resources["utilization"] = (resp3.aggregations.utilization_percentage.value / numberOfResources).toFixed(2);
                        return resources;
                    }
                })
            ]).then(axios.spread((hoursValue, botsData, resources) => {
                prepareSummaryData(hoursValue, botsData, resources);
                setMetricsLoading(false);
            })).catch((error) => {
                setMetricsLoading(false);
            });
        }
    }

    /**
     * returns the automataRunsOnTime(Gauge Chart) Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {automataRunsOnTime} - Automata Runs On Time(%) Array
     */
    function getAutomataRunsOnTime(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setRunsOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.AUTOMATARUNSONTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.AutomataRunsOnTimeMetrics);
                    setAutomataRunsData(formattedData);
                    setRunsOnTimeLoading(false);
                })
                .catch((error) => {
                    setRunsOnTimeLoading(false);
                });
        }

    }

    /**
     * returns the automataStartsOnTime(Gauge Chart) Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {automataStartsOnTime} - Automata Starts On Time(%) Array
     */
    function getAutomataStartsOnTime(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setStartedOnTimeLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.AUTOMATASTARTSONTIME, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareGuageChartData(resp, DashboardConstants.AutomataStartsOnTimeMetrics);
                    setAutomataStartsData(formattedData);
                    setStartedOnTimeLoading(false);
                })
                .catch((error) => {
                    setStartedOnTimeLoading(false);
                });
        }

    }

    /**
     * returns the automataRunsOnTime(Line Chart) Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {automataRunsOnTime} - Automata Runs On Time(%) Array
     */
    function getAutomataRunsOnTimeLineGraph(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setStartedOnTimeLineChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.AUTOMATARUNSONTIMELINEGRAPH, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    //console.log(resp);
                    formattedData = prepareLineGraphData(resp, DashboardConstants.AutomataRunsOnTimeMetrics);
                    setAutomataRunsLineData(formattedData);
                    setStartedOnTimeLineChartLoading(false);
                })
                .catch((error) => {
                    setStartedOnTimeLineChartLoading(false);
                });
        }

    }

    /**
     * returns the automataStartsOnTime(Line Chart) Data
     * @param {*} timeFilterSelections - Time interval Request
     * @param {*} dashboardFilterSelectionsAutomation - Automation Ops Filter Selection Request
     * @param {*} dashboardFilterSelectionsSAP - SAP Ops Filter Selection Request
     * @param {*} workspace - WorkSpace Selection Request
     * @returns {automataStartsOnTime} - Automata Starts On Time(%) Array
     */
    function getAutomataStartsOnTimeLineGraph(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setRunsOnTimeLineChartLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.AUTOMATASTARTSONTIMELINEGRAPH, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    //console.log(resp);
                    formattedData = prepareLineGraphData(resp, DashboardConstants.AutomataStartsOnTimeMetrics);
                    setAutomataStartsLineData(formattedData);
                    setRunsOnTimeLineChartLoading(false);
                })
                .catch((error) => {
                    setRunsOnTimeLineChartLoading(false);
                });
        }

    }

    return (
        <div className="top-margin dashboard productive-metrics">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={metricsLoading}
                        summary={metricsSummaryData}
                        title={DashboardConstants.ProductivityMetrics}
                    />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.ResolutionTime}</div>
                        </div>
                        <div className="gauge-container">
                            <div>
                                <DashboardGaugeChart
                                    loading={gaugeChartLoading}
                                    gaugeChartData={criticalResolutionTime}
                                    title={DashboardConstants.CriticalP1P2}
                                    color={criticalResolutionColor}
                                    isPercentage={true}
                                />
                                {criticalResolutionTime.length ? <div className="gauge-target">{DashboardConstants.CriticalTargetPercentage}</div> : ''}
                            </div>
                            <div>
                                <DashboardGaugeChart
                                    loading={gaugeChartLoading}
                                    gaugeChartData={NormalResolutionTime}
                                    title={DashboardConstants.NormalP3P4}
                                    color={normalResolutionColor}
                                    isPercentage={true}
                                />
                                {NormalResolutionTime.length ? <div className="gauge-target">{DashboardConstants.NormalTargetPercentage}</div> : ''}
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.ResponseTime}</div>
                        </div>
                        <div className="gauge-container">
                            <div>
                                <DashboardGaugeChart
                                    loading={gaugeChartLoading}
                                    gaugeChartData={criticalResponseTime}
                                    title={DashboardConstants.CriticalP1}
                                    color={criticalResponseColor}
                                    isPercentage={true}
                                />
                                {criticalResponseTime.length ? <div className="gauge-target">{DashboardConstants.CriticalTargetPercentage}</div> : ''}
                            </div>
                            <div>
                                <DashboardGaugeChart
                                    loading={gaugeChartLoading}
                                    gaugeChartData={normalResponseTime}
                                    title={DashboardConstants.NormalP2P3P4}
                                    color={normalResponseColor}
                                    isPercentage={true}
                                />
                                {normalResponseTime.length ? <div className="gauge-target">{DashboardConstants.NormalTargetPercentage}</div> : ''}
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.SuccessRateMetrics}</div>
                        </div>

                        <div className="tile-view">
                            <div className="report-container donut-graph-container">
                                <DashboardGaugeChart
                                    loading={SuccessRateLoading}
                                    gaugeChartData={successRateData}
                                    color="#6929c4"
                                    isType="full"
                                    isPercentage={true}
                                    title=""
                                />
                                {successRateData.length ? <div className="full-gauge-target"> {DashboardConstants.CriticalTargetPercentage}</div> : ''}
                            </div>
                            <div className="report-container">
                                <DashboardLineChart
                                    lineGraphData={successRateLineData}
                                    loading={SuccessRateLineChartLoading}
                                    title=""
                                    graphXAxisTitle={DashboardConstants.Month}
                                    graphTitle={DashboardConstants.Percentage}
                                />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.AutomataRunsOnTime}</div>
                        </div>

                        <div className="tile-view">
                            <div className="report-container donut-graph-container">
                                <DashboardGaugeChart
                                    loading={RunsOnTimeLoading}
                                    gaugeChartData={automataRunsdata}
                                    isPercentage={true}
                                    color="#6929c4"
                                    isType="full"
                                    title=""
                                />
                                {automataRunsdata.length ? <div className="full-gauge-target"> {DashboardConstants.CriticalTargetPercentage}</div> : ''}
                            </div>
                            <div className="report-container">
                                <DashboardLineChart
                                    lineGraphData={automataRunsLineData}
                                    loading={RunsOnTimeLineChartLoading}
                                    title=""
                                    graphXAxisTitle={DashboardConstants.Month}
                                    graphTitle={DashboardConstants.Percentage}
                                />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.AutomataStartsOnTime}</div>
                        </div>

                        <div className="tile-view">
                            <div className="report-container donut-graph-container">
                                <DashboardGaugeChart
                                    loading={StartedOnTimeLoading}
                                    gaugeChartData={automataStartsdata}
                                    isPercentage={true}
                                    color="#6929c4"
                                    isType="full"
                                    title=""
                                />
                                {automataStartsdata.length ? <div className="full-gauge-target"> {DashboardConstants.CriticalTargetPercentage}</div> : ''}
                            </div>
                            <div className="report-container">
                                <DashboardLineChart
                                    lineGraphData={automataStartsLineData}
                                    loading={StartedOnTimeLineChartLoading}
                                    title=""
                                    graphXAxisTitle={DashboardConstants.Month}
                                    graphTitle={DashboardConstants.Percentage}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
